declare namespace $ {

	type $mol_link__hint_shm_hitalama_components_launch_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__arg_shm_hitalama_components_launch_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_launch['edit_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_components_launch_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_hitalama_components_demo__definition_shm_hitalama_components_launch_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_launch['definition'] >
		,
		ReturnType< $shm_hitalama_components_demo['definition'] >
	>
	type $shm_hitalama_components_demo__kind_shm_hitalama_components_launch_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_demo['kind'] >
	>
	export class $shm_hitalama_components_launch extends $shm_hitalama_components_preview {
		edit_arg( ): Record<string, any>
		Edit_icon( ): $mol_icon_cog
		Edit( ): $mol_link
		minimal_width( ): number
		demo_model( ): $shm_hitalama_components_demo
		tools( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=launch.view.tree.d.ts.map